// extracted by mini-css-extract-plugin
module.exports = {"singleActivityHeader":"MobileSingleActivity_singleActivityHeader__1VgR0","backBtn":"MobileSingleActivity_backBtn__3xylv"};